import { render, staticRenderFns } from "./CategorySubFilter.vue?vue&type=template&id=1300440a&"
import script from "./CategorySubFilter.vue?vue&type=script&lang=js&"
export * from "./CategorySubFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports